import styled from 'styled-components';
import { ModalPostalCodeStyled } from '../ModalPostalCodeStyled';
import { rem } from 'polished';

export const ModalPostalCodeStyledOV = styled(ModalPostalCodeStyled)`
    .description {
        font-size: ${rem(16)};
        color: ${({ theme }) => theme.colors.black2};
    }

    .type-select {
        .container {
            font-size: ${rem(16)};
            color: ${({ theme }) => theme.colors.black2};
        }

        .checkmark {
            border-color: ${({ theme }) => theme.colors.grey1};
            background: ${({ theme }) => theme.colors.pureWhite};

            &.isSelected {
                background: ${({ theme }) => theme.colors.primary} !important;
                border-color: ${({ theme }) => theme.colors.primary} !important;
            }
        }

        .container .checkmark:after {
            background: ${({ theme }) => theme.colors.black2};
        }
    }

    .select {
        svg {
            path {
                fill: ${({ theme }) => theme.colors.black2};
            }
        }

        .distance-select {
            &__single-value {
                color: ${({ theme }) => theme.colors.black2};
            }

            &__option {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }

            &__option--is-focused {
                background: ${({ theme }) => theme.colors.grey18};
            }

            &__option--is-selected {
                background: ${({ theme }) => theme.colors.black2};
                color: ${({ theme }) => theme.colors.white};
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }

            &__control {
                border-radius: 0;
                border: 1px solid ${({ theme }) => theme.colors.grey4};
            }
        }
    }

    .submit {
        button {
            font-size: ${rem(16)};
            background: ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.black2};

            &:disabled {
                background: ${({ theme }) => theme.colors.primaryDisabled};
                color: ${({ theme }) => theme.colors.grey9};
            }
        }

        .home {
            color: ${({ theme }) => theme.colors.black2};
            border-color: ${({ theme }) => theme.colors.black2};

            svg {
                width: ${rem(14)};
                height: ${rem(14)};
                margin-bottom: -${rem(2)};
                path {
                    fill: ${({ theme }) => theme.colors.black2};
                }
            }

            &:hover:enabled,
            &:focus-visible:enabled {
                background: ${({ theme }) => theme.colors.black2};
                color: ${({ theme }) => theme.colors.white};

                path {
                    fill: ${({ theme }) => theme.colors.white};
                }
            }
        }

        .validate {
            color: ${({ theme }) => theme.colors.black2};

            &:hover:enabled,
            &:focus-visible:enabled {
                background: ${({ theme }) => theme.colors.black2};
                color: ${({ theme }) => theme.colors.pureWhite};
            }
        }
    }

    .selected-dealer {
        .label,
        .name,
        .address-line1,
        .address-line2 {
            font-size: ${rem(16)};
            color: ${({ theme }) => theme.colors.black2};
        }
    }
`;
